import http from "@/http-common";
import lambdahttp from "@/http-lambda-common";
const baseurl = process.env.VUE_APP_AWS_SALENOTE_API
class KDPConfimrSalesNoteDataService {
  selectKDPConfirmSalesNote(data: any): Promise<any> {
    return http.api.post("/selectKDPConfirmSalesNoteInfoList/", data);
  }
  selectKDPConfirmSalesNote_v2(data:any): Promise<any> {
    const url = baseurl + `/kdpsalesnote`;
    return lambdahttp.post<any>(url, data)
  }
  getStatusDetail(data: any): Promise<any> {
    return http.api.post("/getStatusDetail/",data);
  }
  getDistributorName(data:any): Promise<any> {
    const url = baseurl + `/kdpsalesnote`;
    return lambdahttp.post<any>(url, data)
  }
  getPreSignedUrl(data: any): Promise<any>{
    return http.api.post('/getPreSignedUrl/', data);
  }
  checkDistConfirmer(data: any): Promise<any> {
    return http.api.post("/checkKDPDistConfirmer/", data);
  }
  checkSMCConfirmer(data: any): Promise<any> {
    return http.api.post("/checkKDPSMCConfirmer/", data);
  }
  setUserID(data: any): Promise<any> {
    return http.api.post("/setKDPUserID/", data);
  }
  sendDistrAppMail(data: any): Promise<any> {
    return http.api.post("/sendKDPDistrAppMail/", data);
  }
  updateChangedData(data: any): Promise<any> {
    return http.api.post("/updateKDPChangedData/", data);
  }
  getDistributorName_v2(data: any): Promise<any> {
    const url = baseurl + `/kdpsalesnote`;
    return lambdahttp.post<any>(url, data)
  }
}

export default new KDPConfimrSalesNoteDataService();